import { OsadDetails } from "../../hooks/react-query/outbound/freightDetails/useGetOsadDetails";

export const osadSummaryAndShipments = {
  default: {
    summary: {
      areaName: "OSAD",
      bills: 4,
      pieces: 2,
      pallets: 2,
      weight: 3322,
      handlingUnits: 0,
      billsByTags: [
        { id: 2, name: "UC", color: "#FBC02D", bills: 1, position: 20 },
        { id: 81, name: "VC", color: "#AA7EA0", bills: 1, position: 40 },
        { id: 6, name: "LG", color: "#679CB2", bills: 2, position: 50 },
        { id: 75, name: "OVL", color: "#C77563", bills: 2, position: 80 },
        { id: 5, name: "APTM", color: "#69ADA8", bills: 1, position: 110 },
        { id: 4, name: "APTR", color: "#777DE9", bills: 1, position: 120 },
        { id: 9, name: "DTCL", color: "#5E9FE0", bills: 1, position: 190 },
      ],
    },
    shipments: [
      {
        shipmentId: 135280698,
        proNumber: "160160594",
        reasonId: 79,
        reasonCode: "All Short",
        pallets: 1,
        pieces: 2,
        weight: 1210,
        weightUnit: "lbs",
        handlingUnits: 0,
        tags: [
          {
            id: 2,
            name: "UC",
            description: "",
            color: "#FBC02D",
            position: 20,
            bills: 1,
          },
          {
            id: 81,
            name: "VC",
            description: "",
            color: "#AA7EA0",
            position: 40,
            bills: 1,
          },
          {
            id: 6,
            name: "LG",
            description: "",
            color: "#679CB2",
            position: 50,
            bills: 2,
          },
          {
            id: 5,
            name: "APTM",
            description: "",
            color: "#69ADA8",
            position: 110,
            bills: 1,
          },
        ],
        originSic: "ONT",
        destinationSic: "EWR",
        finalDestinationSic: "EWR",
        status: "UNLD",
        dueServiceDate: "2025-11-03",
        loadToSicId: 1,
        loadTo: "EWR",
        currentLocation: {
          type: "OSAD",
          name: "On OSAD",
          trailer: null,
          pullId: null,
          trapId: null,
          tripNumber: null,
        },
      },
      {
        shipmentId: 135953125,
        proNumber: "181656133",
        reasonId: 79,
        reasonCode: "All Short",
        pallets: 1,
        pieces: 0,
        weight: 270,
        weightUnit: "lbs",
        handlingUnits: 0,
        tags: [
          {
            id: 6,
            name: "LG",
            description: "",
            color: "#679CB2",
            position: 50,
            bills: 2,
          },
          {
            id: 4,
            name: "APTR",
            description: "",
            color: "#777DE9",
            position: 120,
            bills: 1,
          },
          {
            id: 9,
            name: "DTCL",
            description: "",
            color: "#5E9FE0",
            position: 190,
            bills: 1,
          },
        ],
        originSic: "ONT",
        destinationSic: "EWR",
        finalDestinationSic: "EWR",
        status: "UNLD",
        dueServiceDate: "2026-02-03",
        loadToSicId: 1,
        loadTo: "EWR",
        currentLocation: {
          type: "OSAD",
          name: "On OSAD",
          trailer: null,
          pullId: null,
          trapId: null,
          tripNumber: null,
        },
      },
    ],
  },
} as const satisfies Record<string, OsadDetails>;
